import { useState } from "react";
import { isImage } from "../../tools/functions";
import { uploadFile } from "../../tools/uploadFile";
import ProgressBar from "./ProgressBar";

const uploadingStates = {
  default: 0,
  uploading: 1,
  uploaded: 2,
  cancelled: 0,
  error: -1,
};
function SimpleFileUpload({
  onChange,
  value,
  inputProps,
}: {
  onChange: (data: any) => void;
  value: any;
  inputProps?: any;
}) {
  const [uploadingState, setUploadingState] = useState(uploadingStates.default);
  const [uploadProgress, setUploadingProgress] = useState({
    percentage: 0,
    size: 0,
    uploaded: 0,
  });
  const changed = async (e) => {
    if (onChange) {
      onChange({
        originalname: e.target.files[0].name,
      });
    }
    setUploadingState(uploadingStates.uploading);
    const abortController = new AbortController();
    const data = await uploadFile(
      e.target.files[0],
      abortController,
      setUploadingProgress
    );
    if (onChange) {
      onChange(data);
    }
    setUploadingState(uploadingStates.uploaded);
    setUploadingProgress({
      percentage: 0,
      size: 0,
      uploaded: 0,
    });
  };

  const onDelete = () => {
    if (onChange) {
      onChange({});
    }
    setUploadingState(uploadingStates.default);
  };
  const { url, width, height, originalname } = value || {};
  if (uploadingState === uploadingStates.uploading) {
    return (
      <RenderUploading
        percentage={uploadProgress.percentage}
        size={uploadProgress.size}
        uploaded={uploadProgress.uploaded}
      />
    );
  } else if (url) {
    return (
      <RenderUploaded
        uri={url}
        onDelete={onDelete}
        originalname={originalname}
        imgWidth={width}
        imgHeight={height}
      />
    );
  } else {
    return (
      <input
        {...(inputProps || {})}
        type={"file"}
        className={"form-control"}
        onChange={changed}
      />
    );
  }
}

function RenderUploaded({ uri, onDelete, imgWidth, imgHeight, originalname }) {
  return (
    <div>
      <a title={"Open in a new tab"} target={"_blank"} href={uri}>
        {isImage(uri) ? (
          <img
            src={uri}
            style={{
              objectFit: "contain",
              maxWidth: "100%",
              maxHeight: 240,
              width: imgHeight !== "auto" ? "auto" : imgWidth,
            }}
            alt={"Uploaded file"}
            className={"bg-light rounded shadow-sm"}
          />
        ) : (
          originalname
        )}
      </a>
      <br />
      <button
        type={"button"}
        className={"btn btn-link text-danger"}
        onClick={onDelete}
      >
        Delete
      </button>
    </div>
  );
}

function RenderUploading({ percentage, size, uploaded }) {
  return (
    <div className={"text-center"}>
      <ProgressBar
        type="primary"
        current={uploaded}
        text={`${percentage}%`}
        max={size}
        height={38}
      />
    </div>
  );
}

export default SimpleFileUpload;
